var map = {
	"./bg-BG.json": 3131,
	"./ca-ES.json": 3132,
	"./cs-CZ.json": 3133,
	"./de-DE.json": 3134,
	"./el-GR.json": 3135,
	"./en-US.json": 1618,
	"./es-ES.json": 3136,
	"./et-EE.json": 3137,
	"./fi-FI.json": 3138,
	"./fr-FR.json": 3139,
	"./he-IL.json": 3140,
	"./it-IT.json": 3141,
	"./ja-JP.json": 3142,
	"./ko-KR.json": 3143,
	"./nb-NO.json": 3144,
	"./nl-NL.json": 3145,
	"./nn-NO.json": 3146,
	"./pl-PL.json": 3147,
	"./pt-BR.json": 3148,
	"./ro-RO.json": 3149,
	"./ru-RU.json": 3150,
	"./sk-SK.json": 3151,
	"./sv-SE.json": 3152,
	"./tr-TR.json": 3153,
	"./zh-CN.json": 3154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3130;